import React from "react";
import { DialogTitle } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
const BulkModalTitle = ({ title, children }) => {
  return /* @__PURE__ */ React.createElement(DialogTitle, null, children ?? /* @__PURE__ */ React.createElement(LocalizedText, { label: title }));
};
export {
  BulkModalTitle
};
//# sourceMappingURL=BulkModalTitle.js.map
